/**
 * @requires jQuery
 * @author Tianyz
 */
let $window = $(window);

/**
 * 判断元素是否进入可见区域
 * 不用兼容 IE8 的话可以用 getBoundingClientRect 实现
 * @param  {object}  $elm           dom 对象
 * @param  {number}  delayDistance  延长距离
 * @return {Boolean}
 */
export function isInViewport($elm, delayDistance = 0) {
  let elmTop = $elm.offset().top;
  let elmBottom = elmTop + $elm.outerHeight();
  let screenTop = $window.scrollTop();
  let screenBottom = screenTop + $window.height();

  if ((screenBottom > elmTop + delayDistance) && (screenTop < elmBottom)) {
    return true;
  }

  return false;
}

/**
 * 监听元素进入可视区域的状态
 * @param  {string}   elmSelector 元素选择器
 * @param  {function} onEnter     进入可视区域的回调 参数为 jQuery 对象
 * @param  {hash} options       {
 *                                delayDistance {number} 延长的触发距离，设为负数则为提前触发的距离
 *                                onLeave       {function} 离开可视区域的操作
 *                              }
 * @return {null}
 */
export default function scrollViewport(elmSelector, onEnter, options) {
  let defaultOptions = {
    delayDistance: 0,
    onLeave: null
  };
  let $targets = $(elmSelector);

  // options = Object.assign(defaultOptions, options);
  // 都是为了兼容 ie8
  $.extend(defaultOptions, options);
  options = defaultOptions;

  function activeInViewport() {
    // TODO: _.debounce
    $targets.each(function() {
      let $elm = $(this);

      if (!isInViewport($elm, options.delayDistance)) {
        if (typeof options.onLeave === 'function') {
          options.onLeave($elm);
        }
      } else {
        onEnter($elm);
      }
    });
  }

  activeInViewport();

  $window.on('scroll', activeInViewport);
}



// WEBPACK FOOTER //
// ./src/utils/scroll-viewport.js